import { Component, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { Screen } from '../../../Models/Screen';
import { Router } from '@angular/router';
import { NavService } from '../../../Services/nav.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['menu-list-item.component.css'],
  //styleUrls: ['./menu-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuListItemComponent {  
  @Input() item: Screen;
  @Input() depth: number = 0;

  constructor(public navService: NavService,
    public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  get expanded(): boolean {
    return this.navService.isExpanded(this.item.ID);
  }

  onItemSelected(item: Screen): void {
    debugger
    if (item.children?.length) {
      this.navService.toggleExpanded(item.ID);
      return;
    }

    if (item.CloseOnSelection) {
      this.navService.closeNav();
    }
  }

  trackById(index: number, item: Screen): number | string {
    return item.ID;
  }
}
